import React from "react";
import { Typography, Box } from "@mui/material";

/**
 * Заголовок секції: однаковий стиль (h4/h5, вирівнювання, відступи).
 */
const SectionTitle = ({
  title,
  subtitle,
  variant = "h4",
  align = "center",
  sx = {},
}) => {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Typography
        variant={variant}
        fontWeight="bold"
        textAlign={align}
        color="text.primary"
        sx={{ fontSize: { xs: "1.2rem", sm: variant === "h4" ? "1.5rem" : "1.25rem" } }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          textAlign={align}
          color="text.secondary"
          sx={{ mt: 1 }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionTitle;
